/**
 * The most attachments one chat message may carry. The SERVER enforces this: the harness refuses a
 * message with more than 20 ("Too many attachments", VMR harness `Inbound.java` `attachments`), so every
 * client caps the composer at it rather than letting a send fail. Mirrors iOS
 * `AttachmentCap.maxMessageAttachments` and Android `AttachmentCap.MAX_MESSAGE_ATTACHMENTS`.
 */
export const MAX_MESSAGE_ATTACHMENTS = 20;

export function attachmentSlotsLeft(current: number): number {
  return Math.max(0, MAX_MESSAGE_ATTACHMENTS - current);
}

export function capIncomingAttachments<T>(current: number, incoming: readonly T[]): { accepted: T[]; refused: number } {
  const accepted = incoming.slice(0, attachmentSlotsLeft(current));
  return { accepted, refused: incoming.length - accepted.length };
}

/**
 * Why the harness refused a send outright (a 4xx before any stream): the row was never persisted, so the
 * bubble must say it was not sent rather than wait for a reply. `too_many_attachments` is the server's
 * own cap above; anything else is a generic refusal. Null when the response is not a refusal.
 */
export type SendRefusal = 'too_many_attachments' | 'refused';

export function sendRefusalFrom(status: number, body: string): SendRefusal | null {
  if (status < 400 || status >= 500) return null;
  return /too many attachments/i.test(body) ? 'too_many_attachments' : 'refused';
}
